import { styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)(() => ({
  fontStyle: "normal",
  fontSize: "18px",
  lineHeight: "130%",
}));
